import { ButtonIcon } from '@workspace/ui/common';

interface ContentCarouselControlsProps {
  slidesLength: number;
  onPrev: () => void;
  onNext: () => void;
}

export function ContentCarouselControls({ slidesLength, onPrev, onNext }: ContentCarouselControlsProps) {
  if (slidesLength <= 1) {
    return <span className="placeholder-div" />;
  }

  return (
    <div className="flex flex-row justify-start mt-xs gap-sm relative z-10">
      <ButtonIcon variant="round" iconName="ChevronLeft" onClick={onPrev} className="bg-transparent" iconSize={24} />
      <ButtonIcon variant="round" iconName="ChevronRight" onClick={onNext} className="bg-transparent" iconSize={24} />
    </div>
  );
}
